module.exports = __webpack_public_path__ + "img/Map.270b25fa.svg";